import React, { useCallback } from 'react'
import Button from '@trileuco/triskel-react-ui/components/ui/Button'
import PropTypes from 'prop-types'
import { useIntl } from '@trileuco/triskel-react-ui/components/i18n'
import { useGetBookable } from 'components/api'
import { useGenerateBookablePath } from 'modules/bookables/routes'

const ButtonWidget = ({ id, referrer }) => {
  const { msg } = useIntl({
    scope: 'balaena.bookableDetailsPage',
    ignoreGlobalScope: true
  })
  const generateBookablePath = useGenerateBookablePath()
  const { bookable, loading } = useGetBookable({ bookableId: id })
  const handleClick = useCallback(() => {
    if (bookable) {
      const bookableUrl = `${generateBookablePath(
        bookable
      )}?referrer=${referrer}`
      window.open(bookableUrl, '_blank')
    }
  }, [bookable, referrer, generateBookablePath])
  return (
    <Button
      disabled={loading}
      text={msg({ id: 'bookNow' })}
      onClick={handleClick}
    />
  )
}

ButtonWidget.propTypes = {
  id: PropTypes.string,
  referrer: PropTypes.string
}

ButtonWidget.displayName = 'ButtonWidget'

export default ButtonWidget
